import{css as t}from"styled-components";var o=function(){var o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"0px";return t(["height:calc(100% - ",");"],o)};export{o as fullHeight};
